import { render, staticRenderFns } from "./NewReport.vue?vue&type=template&id=5f89a62d&scoped=true&"
import script from "./NewReport.vue?vue&type=script&lang=js&"
export * from "./NewReport.vue?vue&type=script&lang=js&"
import style0 from "./NewReport.vue?vue&type=style&index=0&id=5f89a62d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89a62d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
